// extracted by css-extract-rspack-plugin
export default {"headerPillWrapper":"myWOV"};